import { Box, IconButton, Switch, TextField, Typography } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import type { TermSheetExtraSection } from "./types";

const BRAND = "#0E4664";

interface TermSheetCustomSectionEditorProps {
  section: TermSheetExtraSection;
  onChange: (updated: TermSheetExtraSection) => void;
  onDelete: () => void;
}

export function TermSheetCustomSectionEditor({
  section,
  onChange,
  onDelete,
}: TermSheetCustomSectionEditorProps) {
  return (
    <Box
      sx={{
        mt: 1.5,
        p: 2,
        borderRadius: "10px",
        border: "1px dashed #C5C0B8",
        bgcolor: "#FAFAF9",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 2,
        }}
      >
        <Typography sx={{ fontSize: "0.875rem", fontWeight: 600, color: "#182737" }}>
          Custom section
        </Typography>
        <IconButton
          size="small"
          onClick={onDelete}
          aria-label="Delete custom section"
          sx={{ color: "#9CA3AF", "&:hover": { color: "#B42318" } }}
        >
          <DeleteOutlineIcon fontSize="small" />
        </IconButton>
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 2,
        }}
      >
        <Typography sx={{ fontSize: "0.875rem", color: "#374151" }}>
          Include in preview
        </Typography>
        <Switch
          checked={section.included}
          onChange={(event) =>
            onChange({ ...section, included: event.target.checked })
          }
          sx={{
            "& .MuiSwitch-switchBase.Mui-checked": { color: BRAND },
            "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
              bgcolor: BRAND,
            },
          }}
        />
      </Box>

      <Typography
        sx={{
          fontSize: "0.6875rem",
          fontWeight: 600,
          letterSpacing: "0.08em",
          color: "#9CA3AF",
          mb: 1,
        }}
      >
        SECTION LABEL
      </Typography>
      <TextField
        fullWidth
        size="small"
        placeholder="e.g. Additional covenant"
        value={section.label}
        onChange={(event) => onChange({ ...section, label: event.target.value })}
        sx={{
          mb: 2,
          "& .MuiOutlinedInput-root": {
            bgcolor: "#FFFFFF",
            borderRadius: "8px",
            fontSize: "0.875rem",
          },
        }}
      />

      <Typography
        sx={{
          fontSize: "0.6875rem",
          fontWeight: 600,
          letterSpacing: "0.08em",
          color: "#9CA3AF",
          mb: 1,
        }}
      >
        SECTION TEXT
      </Typography>
      <TextField
        fullWidth
        multiline
        minRows={4}
        value={section.content}
        onChange={(event) => onChange({ ...section, content: event.target.value })}
        size="small"
        sx={{
          "& .MuiOutlinedInput-root": {
            bgcolor: "#FFFFFF",
            borderRadius: "8px",
            fontSize: "0.875rem",
            lineHeight: 1.5,
          },
        }}
      />
    </Box>
  );
}
